import { Callout } from '@dev-spendesk/grapes';

import { useVerificationOfPayeeTranslations } from '../../translations/translations';

export const InconsistencyCallout = () => {
  const { t } = useVerificationOfPayeeTranslations();

  return (
    <Callout variant="warning" title={t('inconsistentMatchingResults.title')}>
      {t('inconsistentMatchingResults.description')}
    </Callout>
  );
};
